import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { log, LOG_LEVELS } from '@common/config/app_logger';
import classes from './classes.module.scss';
import withPGTranslation from '../../config/withPGTranslation';
import QuickTopupBanner from '../../../common/quick_topup_banner';
import { sendTyping } from '../../actions/connected_chat';

class Form extends PureComponent {
  static propTypes = {
    sendMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    textAreaRef: PropTypes.object.isRequired,
    onCloseTopup: PropTypes.func.isRequired,
    onTopupClicked: PropTypes.func.isRequired,
    onTopupCompleted: PropTypes.func.isRequired,
    onTopupFailed: PropTypes.func.isRequired
  };

  state = {
    body: ''
  };

  onChange = event => {
    this.setState({ body: event.target.value });
    sendTyping();
  };

  onSend = e => {
    e.preventDefault();
    const { sendMessage, textAreaRef } = this.props;
    const { body } = this.state;

    log(LOG_LEVELS.INFO, 'Chat', 'onSendMessage');
    sendMessage(body);
    this.setState({ body: '' });
    textAreaRef.current.focus();
  };

  isSendAllowed = () => {
    const { body } = this.state;

    return body.trim() !== '';
  };

  onKeyPressed = e => {
    if (!this.isSendAllowed()) return;

    if (e.keyCode === 13 && e.shiftKey === false) {
      log(LOG_LEVELS.INFO, 'Chat', 'onKeyPressed');
      this.onSend(e);
    }
  };

  render() {
    const { body } = this.state;
    const {
      disabled, t, textAreaRef, onCloseTopup, onTopupClicked, onTopupCompleted, onTopupFailed
    } = this.props;
    const sendButton = disabled ? null : (
      <button
        className={ classes.sendBtn }
        type="button"
        onClick={ this.onSend }
        disabled={ !this.isSendAllowed() }
      >
        {t('chat.send')}
      </button>
    );

    return (
      <div className={ classes.formContainer }>
        <QuickTopupBanner
          onClose={ onCloseTopup }
          onButtonClicked={ onTopupClicked }
          onPurchaseCompleted={ onTopupCompleted }
          onPurchaseFailed={ onTopupFailed }
        />
        <div className={ classes.chatSendContainer }>
          <textarea
            className={ classes.chatSendArea }
            placeholder={ t('chat.your_message') }
            value={ body }
            onChange={ this.onChange }
            onKeyDown={ this.onKeyPressed }
            rows="3"
            disabled={ disabled }
            ref={ textAreaRef }
          />
          {sendButton}
        </div>
      </div>
    );
  }
}
export default withPGTranslation(Form);
